import IconModalOk from "./IconModalOk";

const SuccessModal = ({ onClose, message }) => {
  return (
    <div className="w-screen h-screen flex items-center justify-center fixed top-0 left-0 z-[200] bg-gray-900/50 backdrop-blur-sm transition-opacity">
      <div
        className="flex flex-col bg-white shadow-md rounded-lg font-body text-gray-900 text-center relative"
        style={{ height: "375px", width: "375px" }}
      >
        {/* Botón cerrar arriba a la derecha */}
        <div className="flex justify-end px-4 pt-4 mb-4 mt-2">
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 14 14"
            >
              <path
                id="Icon_ionic-md-close"
                d="M21.523,8.923l-1.4-1.4-5.6,5.6-5.6-5.6-1.4,1.4,5.6,5.6-5.6,5.6,1.4,1.4,5.6-5.6,5.6,5.6,1.4-1.4-5.6-5.6Z"
                transform="translate(-7.523 -7.523)"
              />
            </svg>
          </button>
        </div>

        <div
  className="flex flex-col items-center justify-center border-2 border-[#2DC361] rounded-xl mx-8"
  style={{ height: "70%" }}
>
  <div className="w-full flex items-center justify-center mb-4 border-b border-gray-200 px-4 pb-2">
    <IconModalOk />
    <h1 className="font-bold text-xl ml-2">{message}</h1>
  </div>
</div>
      </div>
    </div>
  );
};

export default SuccessModal;
